import { Package } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ServiceIcon = DeckardIconWrapper({ Icon: Package });
